import React from 'react';
import {Column} from "@/core/general/column.component";
import {Row} from "@/core/general/row.component";
import {toPersianNumber} from "@/core/utils/number.utils";

interface ItemTagValueProps {
  tag: string;
  value: string;
}

export const ItemTagValue: React.FC<ItemTagValueProps> = (props) => {
  return (
    <Column className={"w-full"}>
      <Row className="p-2">
        <div className="w-2/3 text-start">{props.tag}</div>
        <div className="w-1/3 text-end">{toPersianNumber(props.value)}</div>
      </Row>
      <div className="w-full mt-1 separatorLine" />
    </Column>
  );
};
